import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { IGalleryCardsProps } from '../galleryCards';

function galleryCardsAdapter(data: any): IGalleryCardsProps {
    return {
        title: data[0].tituloGeneral,
        subtitle: data[0].descripcion
            ? documentToReactComponents(JSON.parse(data[0].descripcion.raw))
            : '',
        categoryName: data[1],
        cards:
            data[0]?.referenciaPlantillaContenido?.map((card: any) => ({
                image: card.imagenPrincipal ? card.imagenPrincipal[0].file.url : '',
                title: card.descripcion
                    ? documentToReactComponents(JSON.parse(card.descripcion.raw))
                    : '',
                subtitle: card.tituloBanner,
                redirect: card.redireccionBoton ? card.redireccionBoton : '',
            })) ?? [],
    };
}

export default galleryCardsAdapter;
